package org.catharsis.spendtel.core.impl

import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.catch

internal fun isFirestorePermissionDenied(error: Throwable): Boolean {
    val message = error.message.orEmpty()
    return message.contains("PERMISSION_DENIED", ignoreCase = true) ||
        message.contains("Missing or insufficient permissions", ignoreCase = true)
}

internal fun <T> Flow<T>.catchFirestorePermissionDenied(
    logLabel: String,
    onDenied: () -> T,
): Flow<T> {
    return catch { error ->
        if (isFirestorePermissionDenied(error)) {
            Napier.d("$logLabel ended after auth change: ${error.message}")
            emit(onDenied())
        } else {
            throw error
        }
    }
}
